const CHASSIS_PART = { chassis: true };
const Chassis = ({ children }) => <group userData={CHASSIS_PART}>{children}</group>;
const isChassisObject = (userData) => userData.chassis === true;
export {
  Chassis,
  isChassisObject
};
